import { emptyForm, emptyName, FormState, NameDraft } from './formState';
import { SourceType } from './sourceTypes';

export type WorkSearchAuthor = {
  family: string;
  given: string;
  needsVerification: boolean;
};

export type WorkSearchResult = {
  id: string;
  title: string;
  authors: WorkSearchAuthor[];
  year: number | null;
  venue: string | null;
  doi: string | null;
  type: SourceType | string;
  source: 'openalex' | 'academia' | 'bibliography' | string;
  volume: string | null;
  issue: string | null;
  page: string | null;
  publisher: string | null;
};

const SOURCE_TYPES: SourceType[] = [
  'article-journal',
  'book',
  'webpage',
  'chapter',
];

function isSourceType(value: string): value is SourceType {
  return (SOURCE_TYPES as string[]).includes(value);
}

function blank(value: string | null | undefined): string {
  return value?.trim() ?? '';
}

function toNameDraft(author: WorkSearchAuthor): NameDraft {
  return {
    family: blank(author.family),
    given: blank(author.given),
    literal: '',
    isOrganization: false,
    needsVerification: author.needsVerification,
  };
}

/** Map a works_search hit onto FormState. Missing fields stay blank. */
export function resultToFormState(result: WorkSearchResult): FormState {
  const type = isSourceType(result.type) ? result.type : 'article-journal';
  const form = emptyForm(type);
  const authors = result.authors.map(toNameDraft).filter((name) => {
    return name.family !== '' || name.given !== '';
  });

  form.title = blank(result.title);
  form.author = authors.length > 0 ? authors : [emptyName()];
  form['container-title'] = blank(result.venue);
  form.volume = blank(result.volume);
  form.issue = blank(result.issue);
  form.page = blank(result.page);
  form.publisher = blank(result.publisher);
  form.DOI = blank(result.doi);
  if (result.year != null && Number.isFinite(result.year)) {
    form.issued = { year: String(result.year), month: '', day: '' };
  }
  return form;
}
